import BaseUseCase from "../../../base_use_case.js.jsx";

class ListInvestmentsUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/projects/investments`,
      params: params
    }).then(result => {
      let { data, headers } = result; 
      let { investments } = data; 

      investments = investments.map((investment) => {
        return {
          ...investment,
          key: investment.updatedAt,
        }
      })
      data.list = investments;
      return {
        data: data,
        headers: headers
      }
    })
  }
}

const instance = new ListInvestmentsUseCase();
export default instance;